// CustomFile type was copied directly
import { ProjectPromotion } from './config';

// from: frontend/apps/admin/src/components/new/upload/index.ts
export type TFile = {
  id: number;
  dataType: string;
  filePath?: string;
  title?: string;
  tourId?: number;
  createdAt: Date;
  updatedAt: Date;
  additionalInformation: null | any;
};
export interface CustomFile extends File, TFile {
  path?: string;
  preview: string;
  lastModifiedDate?: Date;
  url?: string;
  filePath?: string;
  tourId?: number;
  title?: string;
  isFavorite?: boolean;
}

export enum Queries {
  QUERY = 'query',
  GET_OBJECTS = 'getObjects',
  GET_ASSETS = 'getAssets',
  GET_PROJECT_BY_SLUG = 'getProjectBySlug',
}

export enum AssetType {
  Gallery = 'gallery',
  Promotion = 'promotion',
  Blueprint = 'blueprint',
  Logo = 'logo',
  MainImage = 'mainImage',
  HoverImage = 'hoverImage',
  VsObject = 'vsObject',
  Video = 'video',
  Document = 'document',
  ConstructorLogo = 'constructorLogo',
}

export interface Asset {
  id?: number;
  idDraft?: number;
  projectId: number;
  polygonId?: number;
  polygonIdDraft?: number;
  title: string;
  type: AssetType;
  filePath: string;
  url: string;
  urlLarge?: string;
  urlMedium?: string;
  urlSmall?: string;
  order: number;
  yad2Id?: number;
  additionalInformation?: null | any;
}

interface Timeline {
  id: number;
  projectId: number;
  title: string;
  description: string;
  date: string;
}

export type ProjectSpec = {
  [key: number | string]: string[]; // as in API
};

export type SpecValue = {
  key: number;
  id: number | string;
  value: string;
};
export type Spec = {
  id: number | string;
  category: number | string;
  categoryTitle: string;
  values: SpecValue[];
  isNew?: boolean;
  isDeleted?: boolean;
};

export type TAddress = {
  address: string;
  lat: number;
  lng: number;
};

export type TConstructorClient = {
  clientId: number;
  createdAt: string;
  projectId: number;
  updatedAt: string;
};

export type TConstructor = {
  projectId?: number;
  id: number | string;
  idDraft?: number;
  description: string;
  logo?: boolean | CustomFile;
  logoUrl?: string;
  logoFile?: CustomFile;
  name: string;
  isNew?: boolean;
  isDeleted?: boolean;
  email?: string;
  password?: string;
  clientsProjects?: TConstructorClient[];
};

export enum ProjectDealType { // as in API
  Commercial = 'commercial',
  Sale = 'sale',
  Rent = 'rent',
}
// screens dealTypes
export enum DealType {
  Commercial = 'commercial',
  Residential = 'residential', // frontend-only dealType
}
export enum DealTypeResidential {
  Sale = 'sale',
  Rent = 'rent',
}

export enum PromotionBg {
  Color = 'color',
  Image = 'image',
}

export interface Promotion {
  id?: number | string;
  idDraft?: number;
  projectId: number;
  name: string;
  description: string;
  bgColor: string;
  bgType: PromotionBg;
  bgImage?: CustomFile[] | string; // aligned with RHFUpload
  bgImageId: number | null;
  bgImageIdDraft?: number;
  bgIcon?: CustomFile[] | string; // aligned with RHFUpload
  bgIconId: number | null;
  bgIconDraftId?: number;
  textColor?: string;
  overlayColor?: string;
  overlaySecondColor?: string;
  overlayAngle?: number | string;
  cta?: string;
  isNew?: boolean;
  isSelected?: boolean;
  isDeleted?: boolean;
}

export enum ProjectObjectType {
  Building = 'building',
  PrivateHouses = 'privateHouses',
}
export enum ProjectObjectActionType {
  None = 'none',
  Text = 'text',
  Image = 'image',
  Music = 'music',
  Video = 'video',
  Iframe = 'iframe',
  Tab = 'tab',
  Panorama = 'panorama',
  Menu = 'menu',
  Treedis = 'treedis',
  ExperiencePopup = 'experiencePopup',
}

export interface ProjectObject {
  projectId: number;
  id: number;
  name: string;
  floors: number;
  type: ProjectObjectType;
  scaleX?: number;
  scaleY?: number;
  scaleZ?: number;
  positionX?: number;
  positionY?: number;
  positionZ?: number;
  rotationX?: number;
  rotationY?: number;
  rotationZ?: number;
  actionType?: ProjectObjectActionType;
  asset?: Asset[];
  assetId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export enum ProjectPolygonType {
  Apartment = 'apartment',
}
export enum ProjectPolygonStatus {
  Available = 'available',
  Sold = 'sold',
  Reserved = 'reserved',
  Unavailable = 'unavailable',
}

export enum ProjectPolygonPriceBy {
  Total = 'total',
  Sqm = 'm2',
}

export interface ProjectPolygon {
  id?: number | null;
  idDraft?: number;
  projectId: number | null;
  project?: TProject;
  name: string | null;
  scaleX?: number;
  scaleY?: number;
  scaleZ?: number;
  positionX?: number;
  positionY?: number;
  positionZ?: number;
  rotationX?: number;
  rotationY?: number;
  rotationZ?: number;
  // projectObjectId: number; // ignore for now
  promotionLabel?: string | null;
  rooms: number | null;
  number: number | null;
  livingArea: number | null;
  balconyArea: number | null;
  price: string | null;
  priceBy: ProjectPolygonPriceBy;
  tourUrl: string;
  blueprintAsset?: CustomFile;
  showPrice: boolean;
  minFloor: number;
  maxFloor: number;
  floor?: string; // for input, then to be splited back into minFloor and maxFloor
  status: ProjectPolygonStatus;
  type: ProjectPolygonType;
  order?: number;
  assets?: Asset[];
  createdAt?: string;
  updatedAt?: string;
  yad2Id?: number | null;
  isPublic?: boolean;
  isNew?: boolean;
  isDeleted?: boolean;
}

export enum ProjectType {
  New = 'new',
  Seaside = 'seaside',
  Investment = 'investment',
  Garden = 'garden',
  OfficeSale = 'officeSale',
  Duplex = 'duplex',
  Office = 'office',
  RetailCenter = 'retailCenter',
  LogisticsCenter = 'logisticsCenter',
  IndustryPark = 'industryPark',
  TechCenter = 'techCenter',
  OfficeShared = 'officeShared',
  Penthouses = 'penthouses',
}

export type TUser = {
  id: number;
  name: string;
  logo?: string;
  logoUrl?: string;
  isOwner: boolean;
  yad2Subscription: unknown;
};

// aligned to translations
export enum ProjectStatus {
  ActiveOnSite = 'activeOnSite',
  ActiveNotOnSite = 'activeNotOnSite',
  Off = 'off',
  Frozen = 'frozen',
  PendingApproval = 'pendingApproval',
  Expired = 'expired',
  AwaitingRepair = 'awaitingRepair',
  WaitingForOrderTransfer = 'waitingForOrderTransfer',
}

export type TProject = {
  id: number;
  previewId: string;
  slug: string;
  title: string;
  subTitle: string;
  logoUrl?: string;
  mainImageUrl?: string;
  mainImageAsset?: Asset;
  hoverImageUrl?: string;
  description: string;
  address: string;
  lng: number;
  lat: number;
  type: ProjectType[];
  dealType: ProjectDealType;
  status: ProjectStatus;
  syncCrm?: boolean;
  price: number[];
  area: number[];
  rooms: number[];
  emails: string[];
  phoneMobile: string;
  phoneDesktop: string;
  contactName: string;
  specifications: string;
  specs?: Spec[];
  apartmentSpecifications: string[];
  completionDate: string;
  orderType: string;
  yad2StreetId: number;
  yad2HoodId: number;
  yad2CityId: number;
  yad2AreaId: number;
  yad2TopAreaId: number;
  yzerId?: number;
  assets: Asset[];
  timelines: Timeline[];
  projectPromotions: ProjectPromotion[];
  promotions: boolean;
  objects: ProjectObject[];
  polygons: ProjectPolygon[];
  clients: TConstructor[];
  products: number[];
  startDate?: string;
  promotionalLabel?: string;
  immediateOccupancy?: boolean;
  users: TUser[];
  createdAt: string;
  updatedAt: string;
};

export type TProjectSearch = {
  id: number;
  slug: string;
  title: string;
  status: ProjectStatus;
  orderType: string;
  mainImageUrl: string;
  hoverImageUrl: string;
  logoUrl: string;
  address: string;
  lng: number;
  lat: number;
  dealType: ProjectDealType;
  type: ProjectType[];
  promotions: boolean;
  promotionalLabel?: string;
  yad2StreetId: number;
  yad2HoodId: number;
  yad2CityId: number;
  yad2AreaId: number;
  yad2TopAreaId: number;
  yad2Id: number;
  yad2CrmId: string;
  createdAt: string;
  updatedAt: string;
};
